var _path, _path2, _path3, _path4, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcon9(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 25,
    viewBox: "0 0 26 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.9375 21.2109C15.6951 21.1937 15.4914 21.0612 15.33 20.8777C15.2478 20.7869 15.185 20.6799 15.1455 20.5636C15.1059 20.4472 15.0904 20.3239 15.1 20.2012V18.929C15.0904 18.8063 15.1059 18.683 15.1455 18.5666C15.185 18.4502 15.2478 18.3433 15.33 18.2525C15.4914 18.069 15.7176 17.9567 15.96 17.9395H10.4961C10.7415 17.9619 10.972 18.0817 11.13 18.2727C11.2129 18.365 11.2762 18.4737 11.3157 18.5918C11.3553 18.7099 11.3704 18.835 11.36 18.9593V20.2214C11.3443 20.4594 11.2531 20.686 11.1 20.8676C10.9466 21.0503 10.734 21.172 10.5 21.2109H15.9375Z",
    fill: "white",
    stroke: "#363A45",
    strokeWidth: 0.7,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.879 2.53516H4.58896C4.20949 2.56585 3.85731 2.74456 3.60847 3.03269C3.35963 3.32082 3.23409 3.69526 3.25896 4.07516V16.4152C3.23409 16.7951 3.35963 17.1695 3.60847 17.4576C3.85731 17.7458 4.20949 17.9245 4.58896 17.9552H21.879C22.2602 17.927 22.6149 17.7493 22.8659 17.4609C23.1168 17.1725 23.2437 16.7967 23.219 16.4152V4.07516C23.2437 3.69365 23.1168 3.31781 22.8659 3.0294C22.6149 2.74099 22.2602 2.56336 21.879 2.53516Z",
    fill: "white",
    stroke: "#363A45",
    strokeWidth: 0.7,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.67481 21.2148H18.7848C19.13 21.2148 19.4098 21.4947 19.4098 21.8398C19.4098 22.185 19.13 22.4648 18.7848 22.4648H7.6748C7.32963 22.4648 7.0498 22.185 7.0498 21.8398C7.0498 21.4947 7.32963 21.2148 7.67481 21.2148Z",
    fill: "#F7F7F7",
    stroke: "#363A45",
    strokeWidth: 0.7,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M22.1271 16.4305C21.9058 16.6849 21.593 16.8415 21.2568 16.8664H14.2739C17.1449 15.5083 19.5435 12.508 21.2568 3.26758C21.593 3.29245 21.9058 3.4491 22.1271 3.70344C22.3484 3.95779 22.4604 4.28925 22.4385 4.62569V15.5083C22.4604 15.8447 22.3484 16.1762 22.1271 16.4305Z",
    fill: "#00C65E"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M13.2393 16.6348C13.437 16.6348 13.6304 16.5761 13.7948 16.4662C13.9593 16.3564 14.0874 16.2002 14.1631 16.0174C14.2388 15.8347 14.2586 15.6337 14.22 15.4397C14.1815 15.2457 14.0862 15.0675 13.9464 14.9277C13.8065 14.7878 13.6283 14.6926 13.4343 14.654C13.2404 14.6154 13.0393 14.6352 12.8566 14.7109C12.6738 14.7866 12.5177 14.9147 12.4078 15.0792C12.2979 15.2436 12.2393 15.437 12.2393 15.6348C12.2393 15.9 12.3446 16.1543 12.5322 16.3419C12.7197 16.5294 12.974 16.6348 13.2393 16.6348Z",
    fill: "#00C65E"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon9);
export default __webpack_public_path__ + "static/media/icon9.60c84e86516c37a1132dd3b33ff97c2a.svg";
export { ForwardRef as ReactComponent };